import { Routes, Route } from 'react-router-dom';
import { I18nProvider } from '@/i18n';
import { StoreProvider } from '@/store/provider';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/toaster';

// Pages
import Home from '@/pages/Home';
import MyOrg from '@/pages/MyOrg';

// Admin pages
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminUsers from '@/pages/admin/Users';
import AdminApps from '@/pages/admin/Apps';
import AdminReviews from '@/pages/admin/Reviews';
import AdminSettings from '@/pages/admin/Settings';

// Creator pages
import CreatorLayout from '@/pages/creator/CreatorLayout';
import CreatorMyApps from '@/pages/creator/MyApps';
import CreatorSubmit from '@/pages/creator/Submit';
import CreatorEdit from '@/pages/creator/Edit';
import CreatorHistory from '@/pages/creator/History';

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <StoreProvider>
          <Routes>
          {/* Public pages */}
          <Route path="/" element={<Home />} />
          <Route path="/myorg" element={<MyOrg />} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="apps" element={<AdminApps />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Creator routes */}
          <Route path="/creator" element={<CreatorLayout />}>
            <Route index element={<CreatorMyApps />} />
            <Route path="submit" element={<CreatorSubmit />} />
            <Route path="edit/:id" element={<CreatorEdit />} />
            <Route path="history" element={<CreatorHistory />} />
          </Route>
          </Routes>
          <Toaster />
        </StoreProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
